import React from 'react'

type FormData = { name: string; value: string }

export const renderHiddenFormInput = (data: FormData) => (
  <input key={data.name} className="hidden" type="hidden" name={data.name} value={data.value} />
)
